<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item
          ><div class="div1">日志管理</div></el-breadcrumb-item
        >
        <el-breadcrumb-item
          ><div class="div2">登录日志</div></el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <!-- 面包屑导航 -->
    <!-- 查询客户列表 -->
    <div class="query">
      <div class="polling">
        <el-form
          :inline="true"
          ref="form"
          :model="goods"
          label-width=""
          size="mini"
        >
          <el-form-item label="登录地址">
            <el-input
              placeholder="请输入登录地址"
              v-model="goods.ip"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户名称">
            <el-input
              placeholder="请输入用户名称"
              v-model="goods.name"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="goods.status" placeholder="操作状态" clearable>
              <el-option
                v-for="items in options"
                :key="items.dictId"
                :label="items.dictName"
                :value="items.dictId"
              ></el-option>
            </el-select>
          </el-form-item>
          <div class="selectDate">
            <span>登录时间</span>
            <div class="picker">
              <el-date-picker
                v-model="goods.date"
                type="daterange"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy- MM- dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </div>
          </div>
          <el-form-item>
            <el-button type="primary" @click="onSearch(1)">搜索</el-button>
            <el-button @click="reset" :loading="loading">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 查询客户列表 -->
    <div class="btn">
      <el-button
        type="warning"
        @click="batchDeletion()"
        v-if="parArray.indexOf('dailydel') != -1"
        >删除</el-button
      >
    </div>
    <!-- 分配用户列表 -->
    <div class="table">
      <el-table
        ref="multipleTable"
        :data="tableData.list"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        style="width: 100%"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="infoId" label="访问编号"></el-table-column>
        <el-table-column prop="userName" label="用户名称"></el-table-column>
        <el-table-column prop="ipaddr" label="登录地址"></el-table-column>
        <el-table-column prop="statusName" label="登录状态"></el-table-column>
        <el-table-column prop="msg" label="提示信息"></el-table-column>
        <el-table-column prop="accessTime" label="登录日期"></el-table-column>
      </el-table>
      <!-- 分配用户列表 -->
    </div>
    <!-- 分页start -->
    <div class="page" v-if="tableData.totalNum > 0">
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.totalNum"
          prev-text="上一页"
          next-text="下一页"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 分页end -->
    <!-- 对话弹框 -->
    <el-dialog
      :visible.sync="dialogFormVisible"
      :append-to-body="true"
      title="操作日志详情"
    >
      <el-form class="elform">
        <div class="label">
          <el-form-item label="操作模块:">
            <span>{{ detail.title }}</span>
          </el-form-item>
          <el-form-item label="请求地址:">
            <span>{{ detail.operIp }}</span>
          </el-form-item>
        </div>
        <div class="label">
          <el-form-item label="登录信息:">
            <span>{{ detail.operName }}</span>
          </el-form-item>
          <el-form-item label="请求方式:">
            <span>{{ detail.requestMethod }}</span>
          </el-form-item>
        </div>
        <el-form-item label="请求参数:">
          <span>{{ detail.operParam }}</span>
        </el-form-item>
        <el-form-item label="操作方式:">
          <span>{{ detail.method }}</span>
        </el-form-item>

        <el-form-item label="返回参数:">
          <span>{{ detail.jsonResult }}</span>
        </el-form-item>
        <div class="label">
          <el-form-item label="操作状态:">
            <span>{{ detail.statusName }}</span>
          </el-form-item>
          <el-form-item label="操作时间:">
            <span>{{ detail.operTime }}</span>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <!-- <el-button type="primary" :loading="btnloading" @click="dialogFormVisible = false;updateBattery()">确 定</el-button> -->
      </div>
    </el-dialog>
    <!-- 对话弹框 -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      goods: {
        name: "",
        ip: "",
        status: "",
        date: "",
      },
      tableData: [],
      currentPage1: 1,
      brandlist: "",
      options: [],
      brandselect: [],
      dialogFormVisible: false,
      detail: "",
      loading: false,
      multipleSelection: [],
      limits: "",
      parArray: [],
      pageNo: 1,
      pageSize: 10,
    };
  },
  created() {
    this.listAxios("1");
    this.brandSelectBox();
    // 权限设定判断
    this.limits = JSON.parse(sessionStorage.getItem("limit"));
    const params = this.limits.buttonTreeDto.filter(
      (item) => item.menuCode === "dailyLoginCode"
    );
    params[0].buttonList.forEach((item) => {
      this.parArray.push(item.code);
    });
    // 权限设定判断
    document.onkeydown = (e) => {
      let key = window.event.keyCode;
      if (key == 13) {
        this.onSearch();
      }
    };
  },
  beforeRouteLeave(to, form, next) {
    document.onkeydown = null;
    next();
  },
  activated() {
    // this.listAxios("1");
    // this.brandSelectBox();
  },
  methods: {
    // 分页
    handleCurrentChange(val) {
      this.pageNo = val;
      this.listAxios();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.listAxios();
    },
    // 模糊搜索
    onSearch() {
      this.pageNo = 1;
      this.listAxios();
    },
    reset() {
      this.loading = true;
      this.goods = {
        name: "",
        ip: "",
        status: "",
        date: "",
      };
      this.pageNo = 1;
      this.pageSize = 10;
      this.listAxios(1);
    },
    // 商品列表
    listAxios() {
      let beginTime = "";
      let endTime = "";
      if (this.goods.date != "") {
        beginTime = this.goods.date[0] + " 00:00:00";
        endTime = this.goods.date[1] + " 23:59:59";
      }
      this.axios
        .post(
          "/sys/v1/login/info/list",
          {
            request: {
              beginTime: beginTime,
              endTime: endTime,
              ipaddr: this.goods.ip, //登录IP地址
              userName: this.goods.name,
              pageNo: this.pageNo,
              pageSize: this.pageSize,
              status: this.goods.status,
            },
            version: "",
          },
          {
            headers: {
              isLoading: false,
            },
          }
        )
        .then((res) => {
          //   console.log(res);
          if (res.code == 0) {
            this.tableData = res.data;
            setTimeout(() => {
              this.loading = false;
            }, 500);
          } else {
            this.$message.error(res.message);
          }
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 批量删除
    batchDeletion() {
      this.$confirm("确定要删除数据吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = [];
        for (let i = 0; i < this.multipleSelection.length; i++) {
          ids = this.multipleSelection[i].infoId;
        }
        // for(let i =0;i<ids.length;i++){
        //    this.tableData.list.splice(ids[i],1)
        // }
        if (ids == []) {
          this.$message.warning("未选择删除项");
        } else {
          this.axios
            .get("/sys/v1/login/info/delete/" + ids, {
              headers: {
                isLoading: false,
              },
            })
            .then((res) => {
            //   console.log(res);
              if (res.code == 0) {
                this.listAxios("1");
                this.$message({
                  message: "删除成功",
                  type: "success",
                });
              } else {
                this.$message.error(res.message);
              }
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
        }
      });
    },
    // 日志详情
    dailyDetail(row) {
      this.axios
        .get("/sys/v1/operate/log/get?id=" + row.operId, {
          headers: {
            isLoading: false,
          },
        })
        .then((res) => {
        //   console.log("日志详情");
        //   console.log(res);
          if (res.code == 0) {
            this.detail = res.data;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    //** 操作类型 **//
    brandSelectBox() {
      // 操作状态
      this.axios
        .get("/sys/v1/common/by/group?groupId=" + "business_status")
        .then((res) => {
          console.log("操作状态");
          console.log(res);
          if (res.code == 0) {
            this.options = res.data;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    //** 操作类型 **//
  },
};
</script>

<style scoped lang="scss">
.div1 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}
.div2 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}
.elform /deep/.el-form-item__label {
  font-weight: bold;
}
.btn {
  margin-top: 10px;
  /deep/ .el-button {
    padding: 8px 10px;
  }
}
.label {
  /deep/.el-form-item {
    display: inline-block;
    width: 50%;
    vertical-align: middle;
  }
}
.selectDate {
  display: inline-block;
  margin-right: 20px;
  span {
    display: inline-block;
    font-size: 15px;
    margin-right: 15px;
    vertical-align: middle;
  }
  .picker {
    display: inline-block;
    vertical-align: middle;
  }
  /deep/.el-input__inner {
    width: 250px;
    height: 28px;
    line-height: 28px;
  }
  /deep/ .el-date-editor .el-range__icon {
    line-height: 23px;
  }
  /deep/ .el-date-editor .el-range-separator {
    line-height: 23px;
  }
  /deep/.el-date-editor .el-range__close-icon {
    line-height: 22px;
  }
}
.table {
  margin-top: 10px;
  margin-bottom: 40px;
}
.polling {
  margin-top: 10px;
}
/deep/.distpicker-address-wrapper select {
  padding: 0rem 0.75rem;
  height: 30px;
  line-height: 30px;
  font-size: 15px;
}
.query {
  background: #fff;
  padding: 10px;
  .el-form-item {
    display: inline-block;
    margin-right: 20px;
  }
}
.header {
  font-size: 16px;
  color: #2d7edf;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}
/deep/ .query .el-input__inner {
  width: 180px;
}
.selectDate {
  display: inline-block;
  margin-right: 20px;
  span {
    display: inline-block;
    font-size: 15px;
    margin-right: 15px;
    vertical-align: middle;
  }
  .picker {
    display: inline-block;
    vertical-align: middle;
  }
  /deep/.el-input__inner {
    width: 250px;
    height: 28px;
    line-height: 28px;
  }
  /deep/ .el-date-editor .el-range__icon {
    line-height: 23px;
  }
  /deep/ .el-date-editor .el-range-separator {
    line-height: 23px;
  }
  /deep/.el-date-editor .el-range__close-icon {
    line-height: 22px;
  }
}
.operation {
  color: rgb(45, 125, 223);
  cursor: pointer;
  img {
    width: 25px;
    height: 25px;
  }
}
.table {
  /deep/.el-table td,
  .el-table th {
    text-align: center;
  }
  /deep/ .el-table th > .cell {
    text-align: center;
    color: rgb(45, 125, 223);
    font-size: 15px;
  }
  /deep/.el-table__row:hover {
    color: rgb(45, 125, 223);
  }
  /deep/.el-button {
    padding: 0px;
    height: 30px;
    width: 80px;
  }
}
.page {
  text-align: right;
  width: 100%;
  background: #f5f5f5;
  padding-right: 20px;
  position: fixed;
  bottom: 0px;
  right: 0px;
  z-index: 5;

  span {
    font-size: 14px;
    color: #666;
    display: inline-block;
    margin-left: 10px;
  }

  .el-pagination {
    display: inline-block;
    vertical-align: middle;
  }
}
</style>
